//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  props: {
    gameType: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/pages/build821/views/game/item/index.vue